import React from "react";
import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import { HoliDayCalenderFormValues } from "src/models/HoliDayCalender.model";
import ATMDatePicker from "src/components/UI/atoms/formFields/ATMDatePicker/ATMDatePicker";
import ATMSwitchButton from "src/components/UI/atoms/formFields/ATMSwitchButton/ATMSwitchButton";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import ATMMultiSelect from "src/components/UI/atoms/formFields/ATMMultiSelect/ATMMultiSelect";
import useBranches from "src/hooks/useGetBranches";
import ATMCheckbox from "src/components/UI/atoms/formFields/ATMCheckbox/ATMCheckbox";

type Props = {
  formikProps: FormikProps<HoliDayCalenderFormValues>;
  onClose: () => void;
  formType?: "ADD" | "EDIT";
};

const HoliDayCalenderForm = ({ formType, formikProps, onClose }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

  const { branches, isDataLoading: isBranchLoading } = useBranches();

  return (
    <div className="p-4 flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium">
          {" "}
          {formType === "EDIT" ? "Update Holiday" : "Add Holiday"}
        </div>
        <button type="button" className="hover:bg-hover" onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className="flex flex-col gap-4">
        {/* HoliDay Name */}
        <div className="">
          <ATMTextField
            name="holidayName"
            value={values.holidayName}
            onChange={(e) => setFieldValue("holidayName", e.target.value)}
            label="HoliDay Name"
            placeholder="Enter Holiday Name"
            onBlur={handleBlur}
          />
        </div>
        <div>
          <ATMDatePicker
            name="date"
            value={values.date || null}
            onChange={(newValue) => setFieldValue("date", newValue)}
            label="Select Date"
          />
        </div>
        {/* For All Branches */}
        <div className="mt-1 col-span-full">
          <ATMCheckbox
            checked={values?.allBranches}
            onChange={(newValue) => {
              setFieldValue("allBranches", newValue);
              newValue
                ? setFieldValue(
                    "branchId",
                    branches?.map((branch: any) => ({
                      label: `${branch?.branchAddress}, ${
                        branch?.city || ""
                      }, ${branch?.country || ""}`,
                      value: branch?._id,
                    }))
                  )
                : setFieldValue("branchId", []);
            }}
            label="All Branches"
            disabled={isBranchLoading}
          />
        </div>
        {/* Branches  */}
        {values?.allBranches ? null : (
          <div>
            <ATMMultiSelect
              name="branchId"
              value={values.branchId}
              onChange={(newValue) => setFieldValue("branchId", newValue)}
              onBlur={handleBlur}
              label="Branches"
              placeholder="Select Branch"
              isLoading={isBranchLoading}
              options={branches?.map((branch: any) => ({
                label: branch?.branchName,
                value: branch?._id,
              }))}
            />
          </div>
        )}
       
        <div>
          <ATMSwitchButton
            name="optional"
            value={values.optional}
            onChange={(newValue) => setFieldValue("optional", newValue)}
            label="Is-Optional"
          />
        </div>
      </div>
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default HoliDayCalenderForm;
